<div class="global-container">

    <!-- Google Provider button -->  
    <button 
        mat-raised-button 
        color="primary"
        class="base_buttons"
        type="button" 
        style="width: 100%;"
        (click)="loginButtonclicked()">
            google
    </button>

</div>